import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navLinks = [
    { to: "/coaches", label: "Find Coaches" },
    { to: "/shop", label: "Shop" },
    { to: "/#how", label: "How It Works" },
    { to: "/journal", label: "Journal" },
  ];

  const handleLogout = async () => {
    await logout();
    setOpen(false);
    navigate("/");
  };

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-cream/85 backdrop-blur-xl border-b border-cream-border"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <span className="font-serif text-2xl md:text-3xl leading-none text-forest">Golf&nbsp;Start</span>
          <span className="hidden md:inline-block h-4 w-px bg-cream-border" />
          <span className="hidden md:inline-block eyebrow">Est. 2026</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-sans text-sm tracking-wide transition-colors ${
                  isActive ? "text-gold" : "text-forest-dark hover:text-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          {user && (
            <>
              <Link
                to="/dashboard"
                data-testid="header-dashboard-link"
                className="font-sans text-sm tracking-wide text-forest-dark hover:text-gold transition-colors"
              >
                {user.role === "coach" ? "Coach Studio" : "My Lessons"}
              </Link>
              <button
                data-testid="header-logout-btn"
                onClick={handleLogout}
                className="btn-primary"
              >
                Sign&nbsp;Out
              </button>
            </>
          )}
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="h-5 w-5 text-forest" /> : <Menu className="h-5 w-5 text-forest" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-cream-border bg-cream-light px-6 py-6 space-y-5">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block font-sans text-base text-forest-dark"
            >
              {l.label}
            </Link>
          ))}
          <div className="pt-4 border-t border-cream-border space-y-3">
            {user && (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="block font-sans text-base text-forest-dark">
                  {user.role === "coach" ? "Coach Studio" : "My Lessons"}
                </Link>
                <button onClick={handleLogout} className="btn-primary w-full">Sign Out</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
